import { render, staticRenderFns } from "./VotesWidget.vue?vue&type=template&id=21e1870f&scoped=true"
import script from "./VotesWidget.vue?vue&type=script&lang=js"
export * from "./VotesWidget.vue?vue&type=script&lang=js"
import style0 from "./VotesWidget.vue?vue&type=style&index=0&id=21e1870f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e1870f",
  null
  
)

export default component.exports